import React, { useEffect, useState } from 'react'
import { RouteComponentProps, Router } from '@reach/router'
import { NewsWall } from '../pages/newsWall'
import {
  ROUTE_CALENDAR,
  ROUTE_CALENDAR_EXERCISES,
  ROUTE_CALENDAR_EXERCISES_ID,
  ROUTE_CALENDAR_FORM_EDIT,
  ROUTE_CALENDAR_ID,
  ROUTE_CONFIGURATION,
  ROUTE_COOKIES_POLICY,
  ROUTE_DASHBOARD_ID,
  ROUTE_DASHBOARD_TRAINING_ID,
  ROUTE_FORM_GENERATOR,
  ROUTE_FORM_GENERATOR_ASSIGNTO,
  ROUTE_FORM_GENERATOR_FORM_CREATE,
  ROUTE_FORM_GENERATOR_FORM_EDIT,
  ROUTE_FORM_GENERATOR_FORM_RESULTS,
  ROUTE_FORM_GENERATOR_USERS,
  ROUTE_MEDICINES,
  ROUTE_NEWS_WALL,
  ROUTE_NOTIFICATIONS_CONFIG,
  ROUTE_PATIENT_FORMS,
  ROUTE_PATIENT_FORMS_VIEW,
  ROUTE_PATIENTS,
  ROUTE_PRIVACY_POLICY,
  ROUTE_ROLE_PERMISSIONS,
  ROUTE_STATISTICS,
  ROUTE_STATISTICS_ID,
  ROUTE_TRAINING,
  ROUTE_TRAINING_ID,
  ROUTE_TRAININGS,
  ROUTE_TRAININGS_CREATE,
  ROUTE_TRAININGS_FORM_EDIT,
  ROUTE_TRAININGS_ID,
  ROUTE_TREATMENTS,
  ROUTE_TREATMENTS_ID,
  ROUTE_USER_FORMS,
  ROUTE_USER_PROFILE,
  ROUTE_USERS_CREATE,
  ROUTE_USERS_CREATE_ID,
  // ROUTE_ARTICLE,
  // ROUTE_ARTICLES,
  // ROUTE_ARTICLES_FORM,
  // ROUTE_ARTICLES_FORM_EDIT,
  // ROUTE_MESSENGER,
  // ROUTE_MESSENGER_ID,
  // ROUTE_RESOURCES,
  // ROUTE_RESOURCES_ID,
  // ROUTE_RESOURCES_SHARED_WITH_ME,
  // ROUTE_RESOURCES_SHARED_WITH_ME_ID,
  // ROUTE_RESOURCES_FORM_EDIT,
} from './routes-constants'
import { Calendar } from '../pages/calendar'
import { FormGenerator } from '../pages/form-generator'
import { FormGeneratorTable } from '../pages/form-generator-table'
import {
  MEDICINES_TITLE,
  CALENDAR_TITLE,
  CONFIGURATION_TITLE,
  COOKIES_POLICY_TITLE,
  CREATE_PATIENT_TITLE,
  CREATE_TRAINING_TITLE,
  DASHBOARD_TITLE,
  EDIT_PATIENT_TITLE,
  FORM_GENERATOR_ASSIGNTO_TITLE,
  FORM_GENERATOR_EDITOR_TITLE,
  FORM_GENERATOR_FORM_CREATE_TITLE,
  FORM_GENERATOR_RESULTS_TITLE,
  FORM_GENERATOR_TITLE,
  FORM_GENERATOR_USERS_TITLE,
  FORMS_TITLE,
  NEWSWALL_TITLE,
  PATIENT_FORM_VIEW_TITLE,
  PATIENTS_FORMS_TITLE,
  PRIVACY_POLICY_TITLE,
  RESOURCES_NOTIFICATIONS_CONFIG_TITLE,
  ROLE_PERMISSIONS_TITLE,
  STATISTICS_TITLE,
  TRAINING_TITLE,
  TREATMENT_TITLE,
  USER_PROFILE_TITLE,
  USERS_TITLE,
  // ARTICLES_TITLE,
  // MESSENGER_TITLE,
  // RESOURCES_TITLE,
  // RESOURCES_SHARED_WITH_ME_TITLE,
} from './title-constants'
import { FormGeneratorResults } from '../pages/form-generator-results'
import { Configuration } from '../pages/configuration'
import { CalendarForm } from '../pages/calendar-form'
import { PatientFormsTable } from '../pages/patient-forms-list'
import { PatientFormView } from '../pages/patient-forms-view'
import { NotificationsConfig } from '../pages/notifications-config/NotificationsConfig'
import { RolePermissions } from '../pages/role-permissions'
import { ICircleService } from '../modules/users/services/CircleService'
import { User } from '../modules/users/models/User'
import { EditParticipant } from '../pages/users'
import { FormGeneratorUsers } from '../pages/form-generator-users'
import { UserProfile } from '../pages/user-profile'
import { getUserContainer } from '../container/user-module'
import { CIRCLE_SERVICE_KEY } from '../modules/users/container'
import { UsersTable } from '../pages/users-table'
import { Statistics } from '../pages/statistics'
import { Training } from '../pages/training'
import { TrainingView } from '../pages/training-view'
import { Dashboard } from '../pages/dashboard'
import { TreatmentsForm } from '../pages/treatments-form'
import { AllTrainings } from '../pages/trainings'
import { TrainingsView } from '../pages/trainings-view/TrainingsView'
import { CreateTraining } from '../pages/training-form'
import { FormGeneratorAssignTo } from 'pages/form-generator-assignTo'
import { PrivacyPolicy } from '../pages/privacy-policy'
import { CookiesPolicy } from '../pages/cookies-policy'
import { CalendarExercise } from '../pages/calendar-exercise'
import { Medicines } from 'pages/medicines/Medicines'
import { useUserRoles } from '../modules/users/hooks/useUserRoles'
import { ProtectedRoute } from './ProtectedRoute'
// import { ArticlesForm } from '../pages/articles-form'
// import { ArticlesView } from '../pages/articles-view'
// import { ArticlesTable } from '../pages/articles-table'
// import { Messenger } from '../pages/messenger'
// import { Resources } from '../pages/resources'
// import { ResourcesForm } from '../pages/resources-form'

export type RouteProps = {
  title?: string
  subtitle?: string
  id?: string
} & RouteComponentProps

type UserRolesType = ReturnType<typeof useUserRoles>

const circleService = getUserContainer().get<ICircleService>(CIRCLE_SERVICE_KEY)

export const AppRouter: React.FC = () => {
  const [circle, setCircle] = useState<User | undefined>(circleService.getActive())

  useEffect(() => {
    circleService.getActiveObservable().subscribe((c) => setCircle(c))
  }, [circle])

  return (
    <Router component="div">
      <PrivacyPolicy path={ROUTE_PRIVACY_POLICY} title={PRIVACY_POLICY_TITLE} />
      <CookiesPolicy path={ROUTE_COOKIES_POLICY} title={COOKIES_POLICY_TITLE} />

      <ProtectedRoute
        path={ROUTE_NEWS_WALL}
        component={NewsWall}
        title={NEWSWALL_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessHome}
      />

      <ProtectedRoute
        path={ROUTE_USER_PROFILE}
        component={UserProfile}
        title={USER_PROFILE_TITLE}
        canAccess={(r: UserRolesType) => r.canChangeOwnPassword}
      />

      <ProtectedRoute
        path={ROUTE_PATIENTS}
        component={UsersTable}
        title={USERS_TITLE}
        canAccess={(r: UserRolesType) => r.canViewPatients}
      />

      <ProtectedRoute
        path={ROUTE_USERS_CREATE}
        component={EditParticipant}
        title={CREATE_PATIENT_TITLE}
        canAccess={(r: UserRolesType) => r.canViewPatients}
      />

      <ProtectedRoute
        path={ROUTE_USERS_CREATE_ID}
        component={EditParticipant}
        title={EDIT_PATIENT_TITLE}
        canAccess={(r: UserRolesType) => r.canViewPatients}
      />

      <ProtectedRoute
        path={ROUTE_DASHBOARD_ID}
        component={Dashboard}
        title={DASHBOARD_TITLE}
        canAccess={(r: UserRolesType) => r.canViewPatients}
      />

      <ProtectedRoute
        path={ROUTE_FORM_GENERATOR}
        component={FormGeneratorTable}
        title={FORM_GENERATOR_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessForms}
      />

      <ProtectedRoute
        path={ROUTE_FORM_GENERATOR_FORM_EDIT}
        component={FormGenerator}
        title={FORM_GENERATOR_EDITOR_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessForms}
      />

      <ProtectedRoute
        path={ROUTE_FORM_GENERATOR_FORM_CREATE}
        component={FormGenerator}
        title={FORM_GENERATOR_FORM_CREATE_TITLE}
        canAccess={(r: UserRolesType) => r.canCreateForms}
      />

      <ProtectedRoute
        path={ROUTE_FORM_GENERATOR_FORM_RESULTS}
        component={FormGeneratorResults}
        title={FORM_GENERATOR_RESULTS_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessForms}
      />

      <ProtectedRoute
        path={ROUTE_FORM_GENERATOR_USERS}
        component={FormGeneratorUsers}
        title={FORM_GENERATOR_USERS_TITLE}
        canAccess={(r: UserRolesType) => r.canCreateForms}
      />

      <ProtectedRoute
        path={ROUTE_FORM_GENERATOR_ASSIGNTO}
        component={FormGeneratorAssignTo}
        title={FORM_GENERATOR_ASSIGNTO_TITLE}
        canAccess={(r: UserRolesType) => r.canCreateForms}
      />

      <ProtectedRoute
        path={ROUTE_PATIENT_FORMS}
        component={PatientFormsTable}
        title={PATIENTS_FORMS_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessForms}
      />

      <ProtectedRoute
        path={ROUTE_PATIENT_FORMS_VIEW}
        component={PatientFormView}
        title={PATIENT_FORM_VIEW_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessForms}
      />

      <ProtectedRoute
        path={ROUTE_USER_FORMS}
        component={PatientFormsTable}
        title={FORMS_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessForms}
      />

      <ProtectedRoute
        path={ROUTE_CALENDAR}
        component={Calendar}
        title={CALENDAR_TITLE}
        canAccess={(r: UserRolesType) => r.canViewCalendar}
      />

      <ProtectedRoute
        path={ROUTE_CALENDAR_ID}
        component={Calendar}
        title={CALENDAR_TITLE}
        canAccess={(r: UserRolesType) => r.canViewCalendar}
      />

      <ProtectedRoute
        path={ROUTE_CALENDAR_FORM_EDIT}
        component={CalendarForm}
        title={CALENDAR_TITLE}
        canAccess={(r: UserRolesType) => r.canViewCalendar}
      />

      <ProtectedRoute
        path={ROUTE_CALENDAR_EXERCISES}
        component={CalendarExercise}
        title={CALENDAR_TITLE}
        canAccess={(r: UserRolesType) => r.canViewCalendar}
      />

      <ProtectedRoute
        path={ROUTE_CALENDAR_EXERCISES_ID}
        component={CalendarExercise}
        title={CALENDAR_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessCalendar}
      />

      <ProtectedRoute
        path={ROUTE_STATISTICS}
        component={Statistics}
        title={STATISTICS_TITLE}
        canAccess={(r: UserRolesType) => r.canViewOwnStats}
      />

      <ProtectedRoute
        path={ROUTE_STATISTICS_ID}
        component={Statistics}
        title={STATISTICS_TITLE}
        canAccess={(r: UserRolesType) => false}
      />

      <ProtectedRoute
        path={ROUTE_TRAINING}
        component={Training}
        title={TRAINING_TITLE}
        canAccess={(r: UserRolesType) => r.canCompleteUserTraining}
      />

      <ProtectedRoute
        path={ROUTE_DASHBOARD_TRAINING_ID}
        component={Training}
        title={TRAINING_TITLE}
        canAccess={(r: UserRolesType) => r.canViewUserTraining}
      />

      <ProtectedRoute
        path={ROUTE_TRAINING_ID}
        component={TrainingView}
        canAccess={(r: UserRolesType) => r.canViewUserTraining || r.canCompleteUserTraining}
      />

      <ProtectedRoute
        path={ROUTE_TRAININGS}
        component={AllTrainings}
        title={TRAINING_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessTrainingCatalog}
      />

      <ProtectedRoute
        path={ROUTE_TRAININGS_CREATE}
        component={CreateTraining}
        title={CREATE_TRAINING_TITLE}
        canAccess={(r: UserRolesType) => r.canCreateTraining}
      />

      <ProtectedRoute
        path={ROUTE_TRAININGS_FORM_EDIT}
        component={CreateTraining}
        title={CREATE_TRAINING_TITLE}
        canAccess={(r: UserRolesType) => r.canEditTraining}
      />

      <ProtectedRoute
        path={ROUTE_TRAININGS_ID}
        component={TrainingsView}
        canAccess={(r: UserRolesType) => r.canAccessTrainingCatalog}
      />

      <ProtectedRoute
        path={ROUTE_TREATMENTS}
        component={TreatmentsForm}
        title={TREATMENT_TITLE}
        canAccess={(r: UserRolesType) => r.canManageMedicines}
      />

      <ProtectedRoute
        path={ROUTE_TREATMENTS_ID}
        component={TreatmentsForm}
        title={TREATMENT_TITLE}
        canAccess={(r: UserRolesType) => r.canManageMedicines}
      />

      <ProtectedRoute
        path={ROUTE_MEDICINES}
        component={Medicines}
        title={MEDICINES_TITLE}
        canAccess={(r: UserRolesType) => r.canManageMedicines}
      />

      <ProtectedRoute
        path={ROUTE_CONFIGURATION}
        component={Configuration}
        title={CONFIGURATION_TITLE}
        canAccess={(r: UserRolesType) => r.isAdmin || r.isMed}
      />

      <ProtectedRoute
        path={ROUTE_ROLE_PERMISSIONS}
        component={RolePermissions}
        title={ROLE_PERMISSIONS_TITLE}
        canAccess={(r: UserRolesType) => r.isAdmin}
      />

      <ProtectedRoute
        path={ROUTE_NOTIFICATIONS_CONFIG}
        component={NotificationsConfig}
        title={RESOURCES_NOTIFICATIONS_CONFIG_TITLE}
        canAccess={(r: UserRolesType) => r.isAdmin || r.isMed}
      />

      {/* 
      <ProtectedRoute
        path={ROUTE_ARTICLE}
        component={ArticlesView}
        canAccess={(r: UserRolesType) => r.canAccessArticles}
      />
      <ProtectedRoute
        path={ROUTE_ARTICLES_FORM_EDIT}
        component={ArticlesForm}
        title={ARTICLES_TITLE}
        canAccess={(r: UserRolesType) => r.canManageContent}
      />
      <ProtectedRoute
        path={ROUTE_ARTICLES_FORM}
        component={ArticlesForm}
        title={ARTICLES_TITLE}
        canAccess={(r: UserRolesType) => r.canManageContent}
      />
      <ProtectedRoute
        path={ROUTE_ARTICLES}
        component={ArticlesTable}
        title={ARTICLES_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessArticles}
      />
      */}

      {/* 
      <ProtectedRoute
        path={ROUTE_MESSENGER}
        component={Messenger}
        title={MESSENGER_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessMessenger}
      />
      <ProtectedRoute
        path={ROUTE_MESSENGER_ID}
        component={Messenger}
        title={MESSENGER_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessMessenger}
      />
      */}

      {/*
      <ProtectedRoute
        path={ROUTE_RESOURCES}
        component={Resources}
        title={RESOURCES_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessResources}
      />
      <ProtectedRoute
        path={ROUTE_RESOURCES_ID}
        component={Resources}
        title={RESOURCES_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessResources}
      />
      <ProtectedRoute
        path={ROUTE_RESOURCES_SHARED_WITH_ME}
        component={Resources}
        title={RESOURCES_SHARED_WITH_ME_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessResources}
      />
      <ProtectedRoute
        path={ROUTE_RESOURCES_SHARED_WITH_ME_ID}
        component={Resources}
        title={RESOURCES_SHARED_WITH_ME_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessResources}
      />
      <ProtectedRoute
        path={ROUTE_RESOURCES_FORM_EDIT}
        component={ResourcesForm}
        title={RESOURCES_TITLE}
        canAccess={(r: UserRolesType) => r.canAccessResources}
      />
      */}
    </Router>
  )
}
